export default class BaseTopSupporterTheme {

  name = null;
  setting = {};

  constructor(name) {
    this.name = name
  }

  name() {
    return this.name;
  }
  widgetClass() {
    return 'tr-top-supporter';
  }
  themeClass() {
    return `theme-${this.name}`;
  }

  dependencies() {
    return {
      'js': [],
      'css': []
    };
  }

  // font() {}
  // styles() {}
  // html() {}
  // htmlTemplateWhenEmpty(data) {}
  // async setData(elem, data) {}

  setup(setting) {
    this.setting = setting;
  
    if(this.setting['ts_theme'] != 'custom') {
      if (this.setting['ts_sortby'] === 'nominal') {
       let container = h.el('.container')
       container.classList.add('sort-by-nominal');
      }
    }
  }

  setHeight(itemCount) {
    h.setThemeVar('--item-count', itemCount || 1);
  }

  alias(name) {
    return toAlias(name);
  }
  
  useAnimatedRender() {
    return true;
  }

  renderHeader(element) {
    let el =  document.querySelector("#leaderboard")
    var desc_interval = this.setting['ts_interval'] == 1 ? 'Hari Ini' : (this.setting['ts_interval'] + ' Hari Terakhir');

    if(element.title) {
      h.setTextContent(h.el(element.title, el), this.setting['ts_customtitle'] || "Leaderboard");
    }
    if(element.subtitle) {
      h.setTextContent(h.el(element.subtitle, el), this.setting['ts_customsubtitle'] + ' ' + desc_interval || "Top Supporter");
    }
  }

  renderListAnimated(body, prevData = []) {
    const leaderboardEl = document.querySelector('#leaderboard');
    const listEl = leaderboardEl.querySelector('.list');
    const itemHeight = parseFloat(h.getThemeVar('--item-height', `.${this.widgetClass()}.${this.themeClass()}`) || 0);

    let newItems = body.supporter;
    newItems.sort((a, b) => b.sum - a.sum);

    // Create a map of previous positions
    const prevPositions = {};
    const prevItems = h.prop(prevData, 'supporter') || [];
    prevItems.forEach((item, index) => {
      prevPositions[item.uid] = index;
    });

    if(newItems && newItems.length > 0) {

      // Update the DOM without resetting innerHTML
      newItems.forEach((item, newIndex) => {

        const aliases = this.alias(item.supporter_name)
        const newItem = {
          uid: item.uid,
          no : newIndex,
          unitIcon: body.unitIcon, 
          unitName: body.unitName,
          supporterName: aliases.currentAlias,
          supporterPrevName: aliases.prevAlias,
          unitCount: item.sum,
          avatar: item.avatar,
        };

        let itemEl = leaderboardEl.querySelector(`.item[data-uid="${item.uid}"]`);
        if (!itemEl) {
          // Create new element
          const tempEl = document.createElement("div");
          tempEl.innerHTML = this.renderItem(newItem).trim();
          itemEl = tempEl.firstChild;
          listEl.appendChild(itemEl);
        } else {
          // Update existing element
          itemEl.outerHTML = this.renderItem(newItem).trim();
        }

        // Calculate new position
        const newY = newIndex * itemHeight;

        // Animate from old position if exists
        if (prevPositions[item.uid] !== undefined) {
          const oldIndex = prevPositions[item.uid];
          const oldY = oldIndex * itemHeight;

          itemEl = listEl.querySelector(`.item[data-uid="${item.uid}"]`);
          itemEl.style.transform = `translateY(${oldY}px)`;

          // Delay setting new transform to trigger animation
          requestAnimationFrame(() => {
            setTimeout(() => {
              itemEl.style.transform = `translateY(${newY}px)`;
            }, 10);
          });
        } else {
          // New item appears (fade in)
          itemEl.style.opacity = 0;
          itemEl.style.transform = `translateY(${newY}px)`;
          setTimeout(() => {
            itemEl.style.opacity = 1;
          }, 10);
        }
      });

    } else {
      listEl.innerHTML = this.htmlTemplateWhenEmpty(body);
    }

    // Remove items that are no longer in the newData
    listEl.querySelectorAll('.item').forEach(el => {
      const id = el.getAttribute('data-uid');
      if (!newItems.some(item => item.uid === id)) {
        const oldIndex = prevPositions[id];
        const oldY = oldIndex * itemHeight;
        el.style.opacity = 0;
        el.style.transform = `translateY(${oldY-10}px)`;
        setTimeout(() => el.remove(), 500);
      }
    });
  }
  
  renderList(body) {
    const leaderboardEl = document.querySelector('#leaderboard');
    const listEl = leaderboardEl.querySelector('.list');

    let htmlItems = '';
    let newItems = body.supporter;

    if (newItems && newItems.length > 0) {
      newItems.forEach((item, index) => {
        var aliases = this.alias(item.supporter_name)
        htmlItems += this.renderItem({
          no : index,
          unitIcon: body.unitIcon, 
          unitName: body.unitName,
          supporterName: aliases.currentAlias,
          supporterPrevName: aliases.prevAlias,
          unitCount: item.sum,
          avatar: item.avatar,
        });
      });
    } else {
      htmlItems = this.htmlTemplateWhenEmpty(body);
    }

    listEl.innerHTML = htmlItems;
  }
}

export function toAlias(name) {
  // var aliases = (item.supporter_name || '').split('_!!!_');
  var aliases = (name || '').split('_!!!_');
  var currentAlias = aliases[aliases.length - 1] || 'Seseorang';
  var prevAlias = aliases.length > 1 ? aliases[aliases.length - 2] : false;
  return {
    currentAlias: currentAlias,
    prevAlias: prevAlias,
  }
}
